<template>
  <div class="align-self-center relative">
    <div class="relative flex flex-middle gap-xs" @click="isOpened = !isOpened">
      <img
        v-if="userProfile.profileImageUrl"
        class="profile-avatar"
        :src="userProfile.profileImageUrl" />
      <icon v-else icon="user-login"></icon>
      <icon icon="down-arrow" class="login-text margin-s-horizontal"></icon>
    </div>
    <div
      v-dropdown="{ opened: isOpened }"
      class="dropdown bg-bg menu"
      @dropdown:closed="isOpened = false">
      <base-side-nav :items="navLinks" />
      <div class="dropwdown__footer">
        <form-button class="logout" theme="inverse" @click="logout">{{
          t("justopp.header.nav.logout")
        }}</form-button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSideNav from "@/client/components/nav/BaseSideNav.vue";
import FormButton from "@/client/components/base/frameworks/we/form/FormButton.vue";

export default {
  name: "UserDropdown",
  components: {
    BaseSideNav,
    FormButton,
  },
  data: function () {
    return {
      isOpened: false,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
    userProfile() {
      return this.$store.getters["user/profile"];
    },
    userVendor() {
      if (!this.userProfile) {
        return false;
      }

      if (!this.userProfile.Vendor) {
        return false;
      }

      return this.userProfile.Vendor;
    },
    navLinks() {
      return [
        {
          action: {
            type: "routerNavigation",
            data: {
              to: this.userVendor
                ? {
                    name: "company-vendorId-dashboard",
                    params: { vendorId: this.userVendor.id },
                  }
                : { name: "user-dashboard" },
            },
          },
          icon: "dashboard",
          label: "justopp.header.nav.dashboard",
        },
        {
          action: {
            type: "routerNavigation",
            data: {
              to: this.userVendor
                ? {
                    name: "company-vendorId-dashboard-profile",
                    params: { vendorId: this.userVendor.id },
                  }
                : { name: "user-dashboard-profile" },
            },
          },
          icon: "pencil",
          label: "justopp.header.nav.profile",
        },
      ];
    },
  },
  methods: {
    logout() {
      this.$store.commit("user/logout");
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-avatar {
  max-width: 100%;
  max-height: 100%;
  height: 2em;
  width: 2em;
  border-radius: 50%;
  border: 1px solid var(--c-gray);
  padding: 1px;
  object-fit: cover;
}
.menu {
  inset-inline-end: 0;
  width: auto !important;

  * {
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none; /* Firefox all */
    -ms-user-select: none;
    user-select: none;
  }
}

.dropwdown__footer {
  margin-top: var(--margin-s);
  padding-top: var(--margin-m);
  border-top: 1px solid var(--c-gray-2);
  display: flex;
  justify-content: center;
}

.logout {
  --c-inverse: var(--c-gray-5);
}
</style>
